import * as React from 'react';
import { api, handleApiError } from 'services/api';

type ViagemJustificationOption = {
  id: number;
  description: string;
};

export type ViagemJustificationType = 'estadia' | 'fatura' | 'estadia-estorno';

export const useFetchViagensJustificationOptions = () => {
  const fetchViagensJustificationOptions = React.useCallback(
    async (type: ViagemJustificationType) => {
    try {
      const { data } = await api.get<ViagemJustificationOption[]>(
        '/viagens-controle/justifications-options',
        { params: { type } }
      );
      return data;
    } catch (error) {
      throw handleApiError(error);
    }
    },
    []
  );

  return { fetchViagensJustificationOptions };
};
